<template>
    <div class="wrap-content ocr-config-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-12">
                    <h2>Adverse Media - Entity</h2>
                </div>
            </div>
        </div>

        <div
            v-if="!showPageLoader"
            class="config-card-switch sar-configuration"
        >
            <div class="row">
                <div class="col-lg-12">
                    <div class="">
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <div class="row">
                                    <div class="col-md-4 form-radio">
                                        <b-form-group>
                                            <label>
                                                adverse media search?
                                                <span
                                                    v-b-tooltip.hover
                                                    title="Adverse Media is Any News Or information That Suggests Someone Or Something Might Not Be Trustworthy and Reliable"
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >
                                            </label>

                                            <b-form-radio-group
                                                v-model="doAdverseMediaEntity"
                                                :options="radioOptions"
                                                name="doAdverseMediaEntity"
                                                @change="
                                                    getScoreDetails($event)
                                                "
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div v-if="doAdverseMediaEntity == true">
                                    <div class="row">
                                        <div class="col-md-10">
                                            <label for="" class="min-height-20">
                                                Keywords
                                                <span
                                                    v-b-tooltip.hover
                                                    title="The Words and Phrases That People And Type Into Search Engine To Find What They're Looking For"
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >
                                            </label>

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <input
                                                        id="checkbox_adverse"
                                                        v-model="
                                                            useCustomKeywordsAME
                                                        "
                                                        type="checkbox"
                                                    />
                                                    &nbsp;&nbsp;&nbsp;
                                                    <span for="checkbox"
                                                        >Use the default
                                                        keywords
                                                    </span>
                                                </div>
                                            </div>
                                            <br />

                                            <p>
                                                The web search return hits when
                                                it finds sources when these
                                                keywords are linked to the same
                                            </p>
                                        </div>

                                        <div
                                            v-show="useCustomKeywordsAME == false"
                                            class="col-md-12"
                                        >
                                            <div class="d-flex justify-content-end my-2">
                                                <b-form 
                                                    @submit.stop.prevent="resetTableData('KeywordData')"
                                                >
                                                    <base-button
                                                    btn-label="Reset"
                                                    btn-type="submit"
                                                    btn-variant="primary"
                                                    :class="loading ? 'disabled' : ''"
                                                    ></base-button>
                                                </b-form>
                                            </div>

                                            <div
                                                :class="[
                                                    '',
                                                    'tablet-table-small-min-width',
                                                    'mobile-table-responsive-xlg',
                                                    {
                                                        'overflow-hidden':
                                                            !data.length &&
                                                            !showPageLoader,
                                                    },
                                                ]"
                                            >
                                                <b-table
                                                    ref="userAdminVueTable"
                                                    :items="data"
                                                    :fields="fields"
                                                    v-sort="sortBy"
                                                >
                                                    <template
                                                        slot="keyword"
                                                        slot-scope="data"
                                                    >
                                                        <button class="button">
                                                            {{
                                                                data.item
                                                                    .keyword
                                                            }}
                                                        </button>

                                                        <!-- <base-status :status-type=" items.item
                                                                    .keyword">   {{
                                                                items.item
                                                                    .keyword
                                                            }}</base-status> -->
                                                    </template>

                                                   <template
                                                        slot="neutra_terms"
                                                        slot-scope="data"
                                                    >
                                                       <div
                                                            v-for="item in data"
                                                            :key="item.id"
                                                        >
                                                        <div v-if="
                                                                item.neutra_terms !==''
                                                            ">
                                                            <div class="">
                                                                <div v-for="(term, index) in item.neutra_terms" :key="index">
                                                                <button
                                                                    class="button1"
                                                                    
                                                                >
                                                                    {{ term }}
                                                                </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </template>

                                                    <template
                                                        slot="other_words"
                                                        slot-scope="data"
                                                    >
                                                       <div
                                                            v-for="item in data"
                                                                :key="item.id"
                                                           
                                                        >
                                                        <div  v-if="item.other_words !==''">
                                                            <div class="">
                                                                <div v-for="(term, index) in item.other_words" :key="index">

                                                                <button
                                                                    class="button2"
                                                                >
                                                                    {{ term }}
                                                                </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </template>

                                                    <template
                                                        slot="status"
                                                        slot-scope="data"
                                                    >
                                                        <div
                                                            class="action-review"
                                                        >
                                                            <!-- if action modify -->
                                                            <base-action
                                                                icon="icon-edit"
                                                                label="Modify"
                                                                @click="
                                                                    selectedRecord(
                                                                        data.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'modify-Keyword-popup'
                                                                    )
                                                                "
                                                            ></base-action>
                                                            <!-- if action archive -->
                                                            <!-- <base-action
                                                                icon="icon-trash"
                                                                
                                                                label="Archive"
                                                                @click="
                                                                    selectedRecord(
                                                                        data.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'status-update-popup'
                                                                    )
                                                                "
                                                            ></base-action> -->
                                                            <base-action
                                                                :icon="
                                                                    data.item
                                                                        .status ==
                                                                    'active'
                                                                        ? 'icon-trash'
                                                                        : 'icon-done'
                                                                "
                                                                :label="
                                                                    data.item
                                                                        .status ==
                                                                    'active'
                                                                        ? 'Archive'
                                                                        : 'Activate'
                                                                "
                                                                @click="
                                                                    selectedRecord(
                                                                        data.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'status-update-popup'
                                                                    )
                                                                "
                                                            ></base-action>
                                                        </div>
                                                    </template>
                                                </b-table>
                                                <!-- When data is loading -->
                                                <base-table-spinner
                                                    v-if="
                                                        !data.length &&
                                                        !showPageLoader
                                                    "
                                                ></base-table-spinner>
                                                <!-- When record not found -->
                                                <!-- <base-no-record-found
                                                    v-if="
                                                        !data.length &&
                                                        !showPageLoader
                                                    "
                                                ></base-no-record-found> -->
                                            </div>
                                            <base-records
                                                :path="this.keyword_path"
                                                :query="query"
                                                :reset="reset"
                                                :show-pagination="true"
                                            ></base-records>
                                            <p>
                                                New Keywords may be added, but
                                                this can have an unpredictable
                                                effect on screening results and
                                                should be tested.
                                                <br />
                                                Please contact us if you wish to
                                                add new keywords to your search
                                            </p>

                                            <!-- <pre>selected: {{ selected }}</pre> -->
                                            <!-- <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                                aria-controls="adverse-media-table"
                                                style="color: aqua"
                                            ></b-pagination> -->
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-10">
                                            <label>
                                                Proximity Score Table
                                                <span
                                                    v-b-tooltip.hover
                                                    title="It Can Help to Identify Related Terms and Improve Natural Language Processing Algorithms"
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >
                                            </label>
                                            <p>
                                                The scores measure the
                                                similarity and closeness of
                                                different words based on their
                                                distance from each other.
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <p> Threshold 
                                            &nbsp;&nbsp;&nbsp;
                                            <input
                                                v-model="thresholdAME"
                                                type="text"
                                                :disabled="disabled == 1"
                                                style="width: 30px"
                                            />
                                        </p>
                                        </div>
                                        <div class="col-md-6 action-review">
                                            <!-- if action modify -->

                                            <base-action
                                                icon="icon-edit"
                                                label="Modify"
                                                style="width: 100%"
                                                @click="
                                                 selectedRecord(
                                                    thresholdAME
                                                                )
                                                    $bvModal.show(
                                                        'modify-ThresHold-detection-popup'
                                                    )
                                                "
                                            ></base-action>
                                            <modifyThresHoldDetectionPopup
                                                @click="
                                                    ChangeThresholdAm($event)
                                                "
                                            />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <input
                                                id="checkbox_adverse"
                                                v-model="useCustomScoreSetsAME"
                                                type="checkbox"
                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <span for="checkbox"
                                                >Use the default score
                                            </span>
                                        </div>
                                    </div>
                                    <br />

                                    <div
                                        v-if="useCustomScoreSetsAME == false"
                                        class="row"
                                    >

                                    <div class="col-md-10">
                                        <div class="d-flex justify-content-end my-2">
                                        <b-form 
                                            @submit.stop.prevent="resetTableData('ProximityScoreData')"
                                        >
                                            <base-button
                                            btn-label="Reset"
                                            btn-type="submit"
                                            btn-variant="primary"
                                            :class="loading ? 'disabled' : ''"
                                            ></base-button>
                                        </b-form>
                                        </div>
                                    </div>

                                        <div class="col-md-10">
                                            <div>
                                                <h4 style="text-align: center">
                                                    No of words
                                                </h4>
                                            </div>
                                            <div
                                                :class="[
                                                    '',
                                                    'tablet-table-small-min-width',
                                                    'mobile-table-responsive-xlg',
                                                    {
                                                        'overflow-hidden':
                                                            !data1.length &&
                                                            !showPageLoader,
                                                    },
                                                ]"
                                            >
                                                <b-table
                                                    :items="data1"
                                                    :fields="score_fields"
                                                    v-sort="sortBy"
                                                    @change="
                                                        getScoreDetails($event)
                                                    "
                                                >
                                                    <template
                                                        slot="status"
                                                        slot-scope="data1"
                                                    >
                                                        <div
                                                            class="action-review"
                                                        >
                                                            <!-- if action modify -->
                                                            <base-action
                                                                icon="icon-edit"
                                                                label="Modify"
                                                                @click="
                                                                    ChangeScore(
                                                                        $event
                                                                    )
                                                                    selectedRecord(
                                                                        data1.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'modify-word-score-popup'
                                                                    )
                                                                    ChangeScore(
                                                                        $event
                                                                    )
                                                                "
                                                            ></base-action>
                                                            
                                                        </div>
                                                    </template>
                                                </b-table>
                                                <!-- When data is loading -->
                                                <base-table-spinner
                                                    v-if="
                                                        !data1.length &&
                                                        showPageLoader
                                                    "
                                                ></base-table-spinner>
                                                <!-- When record not found -->
                                                <base-no-record-found
                                                    v-if="
                                                        !data1.length &&
                                                        !showPageLoader
                                                    "
                                                ></base-no-record-found>
                                            </div>
                                        </div>

                                        <!-- <pre>selected: {{ selected }}</pre> -->
                                    </div>
                                    <br />

                                    <div class="row">
                                        <div class="col-md-10">
                                            <label for="" class="min-height-20">
                                                Set the proximity distance
                                                score:
                                                <!-- <span
                                                    v-b-tooltip.hover
                                                    title="The Words and Phrases That People And Type Into Search Engine To Find What They're Looking For"
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >-->
                                            </label>

                                            <p>
                                                This table shows you how many
                                                words would fail in the bucket
                                                in order to score points<br />
                                                Optional: You can change the
                                                threshold value and score
                                                settings.
                                            </p>

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <input
                                                        id="checkbox_adverse"
                                                        v-model="
                                                            useCustomScoreBinsAME
                                                        "
                                                        type="checkbox"
                                                    />
                                                    &nbsp;&nbsp;&nbsp;
                                                    <span for="checkbox"
                                                        >Use the default Scores
                                                    </span>
                                                </div>
                                            </div>
                                            <br />
                                        </div>

                                        <div
                                            v-if="useCustomScoreBinsAME == false"
                                            class="col-md-8"
                                            style="width:100%"
                                        >
                                            <div class="d-flex justify-content-end my-2">
                                                <b-form 
                                                    @submit.stop.prevent="resetTableData('proximityDistanceScoreData')"
                                                >
                                                    <base-button
                                                    btn-label="Reset"
                                                    btn-type="submit"
                                                    btn-variant="primary"
                                                    :class="loading ? 'disabled' : ''"
                                                    ></base-button>
                                                </b-form>
                                            </div>
                                            <div
                                                :class="[
                                                    '',
                                                    'tablet-table-small-min-width',
                                                    'mobile-table-responsive-xlg',
                                                    {
                                                        'overflow-hidden':
                                                            !items_bin_score.length &&
                                                            !showPageLoader,
                                                    },
                                                ]"
                                            >
                                                <b-table
                                                    id="adverse-media-table"
                                                    :items="items_bin_score"
                                                    :fields="
                                                        items_bin_score_field
                                                    "
                                                    small
                                                >
                                                <template
                                                        slot="score"
                                                        slot-scope="items_bin_score"
                                                    >

                                                    <div>
                                                        {{ items_bin_score.item.score}}
                                                    </div>
                                                    <!-- <div
                                                          
                                                            v-if="
                                                                items_bin_score.item
                                                                    .id == 1
                                                                
                                                            "
                                                        >
                                                    {{ ` ${min_close} - ${max_close} words `}}
                                                    </div>
                                                    <div
                                                          
                                                          v-if="
                                                              items_bin_score.item
                                                                  .id == 2
                                                              
                                                          "
                                                      >
                                                  {{ ` ${min_medium} - ${max_medium} words `}}
                                                  </div>
                                                  <div
                                                          
                                                          v-if="
                                                              items_bin_score.item
                                                                  .id == 3
                                                              
                                                          "
                                                      >
                                                  {{ ` ${min_far} - ${max_far} words `}}
                                                  </div> -->
                                                    </template>
                                                    <template
                                                        slot="status"
                                                        slot-scope="items_bin_score"
                                                    >
                                                        <div
                                                            class="action-review"
                                                        >
                                                            <!-- if action modify -->
                                                            <base-action
                                                                icon="icon-edit"
                                                                label="Modify"
                                                                @click="
                                                                    selectedRecord(
                                                                        items_bin_score.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'modify-bin-entity'
                                                                    )
                                                                "
                                                            ></base-action>
                                                            <!-- if action archive -->
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </div>
                                        <div
                                            v-if="useCustomScoreBinsAME == false"
                                            class="col-md-12"
                                        >
                                           

                                            <!-- <pre>selected: {{ selected }}</pre> -->
                                            <!-- <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                                aria-controls="adverse-media-table"
                                                style="color: aqua"
                                            ></b-pagination> -->
                                        </div>
                                    </div>

                                    <div class="row" >
                                        <div class="col-md-10">
                                            <b-form-group>
                                                <label>
                                                    Category Checks
                                                    <span
                                                        v-b-tooltip.hover
                                                        title="Involves Categorizing The Name being checked into Different Groups Based On their Origin and Cultural Context. "
                                                        class="material-icons"
                                                        style="font-size: 15px"
                                                        >help_outline</span
                                                    >
                                                </label>
                                                <b-form-radio-group
                                                    v-model="useCategoryCheckAME"
                                                    :options="radioOptions"
                                                    name="AdverseMediaSearch"
                                                    @change="
                                                        getScoreDetails($event)
                                                    "
                                                ></b-form-radio-group>
                                            </b-form-group>

                                           
                                        </div>
                                    </div>
                                    <div v-if="useCategoryCheckAME == true">
                                        <p>
                                                Select the categories you wish
                                                to exclude in your results.
                                            </p>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <input
                                                id="checkbox_useCustomCategoriesAM"
                                                v-model="useCustomCategoriesAME"
                                                type="checkbox"
                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <span for="checkbox"
                                                >Use the default categories
                                            </span>
                                        </div>
                                    </div>
                                    <br />
                                    <div v-if="useCustomCategoriesAME == false">

                                        <div class="row">
                                            <b-form 
                                                class="col-md-5 text-right"
                                                @submit.stop.prevent="resetTableData('CategorieData')"
                                            >
                                                <base-button
                                                btn-label="Reset"
                                                btn-type="submit"
                                                btn-variant="primary"
                                                :class="loading ? 'disabled' : ''"
                                                ></base-button>
                                            </b-form>
                                        </div>

                                        <div v-if="loading" class="col-md-4">
                                            <base-table-spinner></base-table-spinner>
                                        </div>
                                        <b-tabs v-else content-class="mt-3">
                                            <b-tab
                                                title="All Categories"
                                                active
                                            >
                                                <b-row align-h="start">
                                                    <b-col cols="4">
                                                        <div class="container">
                                                            <div>
                                                                <div
                                                                    v-for="(
                                                                        item,
                                                                        index
                                                                    ) in Adverse_Check_items"
                                                                    :key="index"
                                                                >
                                                                    <input
                                                                        :id="`item-${index}`"
                                                                        type="checkbox"
                                                                        :value="
                                                                            item.id
                                                                        "
                                                                        :checked="
                                                                            item.checked
                                                                        "
                                                                        @change="
                                                                            handleCheckboxChange(
                                                                                item
                                                                            )
                                                                        "
                                                                    />
                                                                    &nbsp;
                                                                    <label
                                                                        :for="`item-${index}`"
                                                                        >{{
                                                                            item.value
                                                                        }}</label
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-tab>
                                            <b-tab title="Most Used">
                                                <b-col cols="4">
                                                    <div class="container">
                                                        <div>
                                                            <div
                                                                v-for="(
                                                                    item, index
                                                                ) in Adverse_Check_items_most_used"
                                                                :key="index"
                                                            >
                                                                <input
                                                                    :id="`item-${index}`"
                                                                    type="checkbox"
                                                                    :value="
                                                                        item.id
                                                                    "
                                                                    :checked="
                                                                        item.checked
                                                                    "
                                                                    @change="
                                                                        handleCheckboxChangeMostUsed(
                                                                            item
                                                                        )
                                                                    "
                                                                />
                                                                &nbsp;
                                                                <label
                                                                    :for="`item-${index}`"
                                                                    >{{
                                                                        item.value
                                                                    }}</label
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-col></b-tab
                                            >
                                        </b-tabs>
                                    </div>
                                </div>
                                    <div class="row">
                                        <div class="col-md-10">
                                            <br />
                                            <label>
                                                Sentiment Checks
                                                <span
                                                    v-b-tooltip.hover
                                                    title="Article describing an individual raising awareness of the harms of drug use → sentiment score 0.4 (positive tone)
                                                            Article describing an individual suspected of illegal drug use → sentiment score -0.8 (negative tone)"
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >
                                            </label>
                                            <p>
                                                For each result, an AI model is used to analyse the tone of the text in sentences where the name is mentioned, and give it score between +1 (most positive) and -1 (most negative). Any results given a score higher (more positive) than the threshold will be discarded.
                                            </p>
                                        </div>

                                        <div class="col-md-10">
                                            <b-form-radio-group
                                                v-model="useSentimentCheckAME"
                                                :options="radioOptions"
                                                name=""
                                            ></b-form-radio-group>
                                        </div>
                                    </div>

                                    <br />
                                    <div v-if="useSentimentCheckAME == true">
                                        <input
                                            v-model="sentimentThresholdAME"
                                            id="myinput"
                                            type="range"
                                            :min="-1"
                                            :max="1"
                                            :step=".01"
                                            :scale="1"
                                        />
                                        <p>{{ sentimentThresholdAME }}</p>
                                        <!-- <range-slider
                                            :value="sentimentThresholdAME"
                                            :min="-1"
                                            :max="1"
                                            :step="1"
                                            :scale="1"
                                        /> -->
                                    </div>

                                    <div class="row">
                                        <div class="col-md-10">
                                            <label>
                                                Exclude URL
                                                <span
                                                    v-b-tooltip.hover
                                                    title=" A method for Restricting the crawler"
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >
                                                <i
                                                    class="fa fa-question-circle-o"
                                                    aria-hidden="true"
                                                ></i>
                                            </label>
                                            <p></p>
                                        </div>

                                        <div class="col-md-10">
                                            <b-form-radio-group
                                                v-model="useExcludedURLsAME"
                                                :options="radioOptions"
                                                name=""
                                            ></b-form-radio-group>
                                        </div>
                                    </div>

                                    <div
                                        v-if="useExcludedURLsAME == true"
                                        class="row"
                                    >
                                        <div class="col-md-10">
                                            <br />
                                            <p>
                                                Add any URL you wish to exclude
                                                from your search
                                            </p>

                                            <div
                                                v-for="(input, index) in url_array"
                                                :key="index"
                                                class="input wrapper flex items-center"
                                            >
                                                <!--h-10 rounded-l-->
                                                <input
                                                    v-model="url_array[index]"
                                                    type="url"
                                                    class="outline-none p-2"
                                                    placeholder="Paste URL and type"
                                                    style="width: 50%"
                                                />
                                          
                                                <!--          Remove Svg Icon-->
                                                <svg
                                                    v-show="url_array.length > 1"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    width="24"
                                                    height="24"
                                                    class="ml-2 cursor-pointer"
                                                    @click="
                                                        removeUrlArray(index)
                                                    "
                                                >
                                                    <path
                                                        fill="none"
                                                        d="M0 0h24v24H0z"
                                                    />
                                                    <path
                                                        fill="#EC4899"
                                                        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
                                                    />
                                                </svg>
                                            </div>
                                            <br>
                                                  <!--          Add Svg Icon-->
                                                  <svg
                                                    
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    width="24"
                                                    height="24"
                                                    class="ml-2 cursor-pointer"
                                                    @click="
                                                        addUrlArray()
                                                    "
                                                >
                                                    <path
                                                        fill="none"
                                                        d="M0 0h24v24H0z"
                                                    />
                                                    <path
                                                        fill="green"
                                                        d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
                                                    />
                                                </svg>
                                        </div>
                                    </div>
                                     <br />
                                     <!-- Country of residence configuration -->
                                     <div class="row">
                                        <div class="col-md-10">
                                            <label>
                                                URL Region Boosting
                                                <span
                                                    v-b-tooltip.hover
                                                    title=""
                                                    class="material-icons"
                                                    style="font-size: 15px"
                                                    >help_outline</span
                                                >
                                            </label>
                                            <p>
                                                Configure URL region boosting score.
                                            </p>
                                        </div>
                                        <div class="col-md-10">
                                            <b-form-radio-group
                                                v-model="useURLRegionBoostAME"
                                                :options="radioOptions"
                                                name=""
                                            ></b-form-radio-group>
                                        </div>
                                    </div>
                                    <div v-if="useURLRegionBoostAME == true">
                                        <br />
                                    <div
                                        class="row"
                                    >
                                    <div class="col-md-8">
                                            
                                            <div
                                                :class="[
                                                    '',
                                                    'tablet-table-small-min-width',
                                                    'mobile-table-responsive-xlg',
                                                    {
                                                        'overflow-hidden':
                                                            !data1.length &&
                                                            !showPageLoader,
                                                    },
                                                ]"
                                            >
                                                <b-table
                                                    :items="country_items"
                                                    :fields="country_fields"
                                                >
                                                    <template
                                                        slot="action"
                                                        slot-scope="row"
                                                    >
                                                        <div
                                                            class="action-review"
                                                        >
                                                            <!-- if action modify -->
                                                            <base-action
                                                                icon="icon-edit"
                                                                label="Modify"
                                                                @click="
                                                                    openCountryModal(
                                                                        row.index
                                                                    )
                                                                "
                                                            ></base-action>
                                                            
                                                        </div>
                                                    </template>
                                                </b-table>
                                                <modify-country-modal :show-modal="showCountryModal" :edited-item="editedCountryItem" @submit="submitCountryForm"></modify-country-modal>
                                                <!-- When data is loading -->
                                                <base-table-spinner
                                                    v-if="
                                                        !data1.length &&
                                                        showPageLoader
                                                    "
                                                ></base-table-spinner>
                                                <!-- When record not found -->
                                                <base-no-record-found
                                                    v-if="
                                                        !data1.length &&
                                                        !showPageLoader
                                                    "
                                                ></base-no-record-found>
                                            </div>
                                    </div> 
                                    </div>
                                     <br />
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <b-button
                                    :class="loading ? 'disabled' : ''"
                                    variant="primary"
                                    type="submit"
                                    @click.prevent="updateSARConfigurations()"
                                >
                                    <span class="btn-text">UPDATE</span>
                                    <span class="loader"></span>
                                </b-button>
                                <base-toast></base-toast>
                            </div>
                        </div>
                    </div>
                    <modify-word-score-popup :setWordScoreRecord="setWordScoreRecord"></modify-word-score-popup>
                    <modify-word-table-popup></modify-word-table-popup>
                    <modify-bin></modify-bin>
                  <modify-bin-entity :loadWordDistanceScore="loadWordDistanceScore"></modify-bin-entity>
                    <status-update-popup></status-update-popup>

                    <modify-Keyword-popup></modify-Keyword-popup>
                </div>
                <!-- <modify-ThresHold-detection-popup>
                
               </modify-ThresHold-detection-popup> -->
                <!--  When data is loading -->
                <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            </div>
        </div>
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import ModifyKeywordPopup from '@/components/popups/ModifyKeyword.vue'
//import ModifyBinScore from '@/components/popups/Modifybinscorepopup.vue'
import modifyThresHoldDetectionPopup from '@/components/popups/ModifyThresHoldDetectionPopup.vue'
import ModifyWordScorePopup from '@/components/popups/ModifyWordScorePopup.vue'
import ModifyWordTablePopup from '@/components/popups/ModifyWordTablePopup.vue'

import ModifyBin from '@/components/popups/Modifybinscore.vue'
import ModifyBinEntity from '@/components/popups/modifyBinEntity.vue'
import ModifyCountryModal from '@/components/popups/ModifyCountryModal.vue';

//import wizardForm from '@/components/wizardForm.vue'

const sarApi = new resource('configurations/sar')
const sarApi1 = new resource('configurations/ProximityDistanceScore/?type=Entity')
const getwebconfig = new resource('configurations/webSearch')
const configApi = new resource('configurations/updateConfigurationWeb')
const userWebSearchApi =  new resource('users/smartScreeningUserConfigUpdate')
export default {
    // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    name: 'AddRemove',
    components: {
        modifyThresHoldDetectionPopup,
        ModifyWordScorePopup,
        ModifyWordTablePopup,
        ModifyKeywordPopup,
        ModifyBin,
        ModifyBinEntity,
        ModifyCountryModal,
        //     wizardForm
    },
    /*

    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > data


    data() {
        return {
            keyword_path: '',
            url_array:[''],
            length_url:0,
            min_close:0,
            max_close:10,
            min_medium:0,
            max_medium:0,
            min_dar:0,
            max_far:0,
            sliderValue: 0,
            Adverse_Check_items: [], // fetched from API
            Adverse_Check_items_most_used: [],
            Adverse_Check_selectedItems: [], // selected items will be stored here
            data1: [],
            //    data: [],
            URLS: [{ phone: '' }],
            useCustomScoreSetsAME: false,
            useCustomKeywordsAME: false,
            useSyntaxCheckAME: true,
            useCustomScoreBinsAME: false,
            useSentimentCheckAME: false,
            sentimentThresholdAME: 0,
            checked_score: false,
            title: 'Rick Grimes',
            disabled: 1,
            ThresoHld: 75,
            thresholdAME: 75,
            showPageLoader: true,
            perPage: 5,
            currentPage: 1,
            items_bin_score: [
                { id: 1, score:  `1-10 words`, proximity: 'Close', status: '' },
                {
                    id: 2,
                    score: '11-50 words',
                    proximity: 'Medium',
                    status: '',
                },
                { id: 3, score: '50-100 words', proximity: 'Far', status: '' },
            ],
            items_bin_score_field: [
                {
                    key: 'score',
                    label: 'Score',
                    sortable: false,
                    //      tdClass: 'items_bin_score_field',
                },
                {
                    key: 'proximity',
                    label: 'Proximity',
                    sortable: false,
                    //   tdClass: 'items_bin_score_field',
                },
                {
                    key: 'status',
                    label: 'Action',
                    sortable: false,
                },
            ],
            radioOptions: [
                { text: 'Enable', value: true },
                { text: 'Disable', value: false },
            ],
            doAdverseMediaEntity: false,
            useCategoryCheckAME: false,
            useCustomCategoriesAME: false,
            customCategoriesAME: [],
            useExcludedURLsAME: false,
            excludedURLsAME: [],
            customScoreSetsAME: [],
            customScoreBinsAME: [],
            doPEP: false,
            pepmediaurl: false,
            sortBy:"",
            fields: [
                {
                    key: 'keyword',
                    label: 'keyword',
                    // class: 'text-center w-100px',
                    sortable: true,

                    tdClass: 'items_bin_score_field',
                },
                {
                    key: 'neutra_terms',
                    label: 'Neutralising Terms',
                    //  class: 'text-center w-230px',
                    tdClass: 'items_bin_score_field',
                    sortable: false,
                },
                {
                    key: 'other_words',
                    label: 'Required Terms',
                    // class: 'text-center w-230px',
                    tdClass: 'items_bin_score_field',
                    sortable: false,
                },
                {
                    key: 'status',
                    label: 'Action',
                    //   class: 'text-center w-230px',
                    tdClass: 'items_bin_score_field',
                    sortable: false,
                },
            ],

            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'keyword',
                sortOrder: 'asc',
            },
            query1: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'keyword',
                sortOrder: 'asc',
            },
            reset1: new Date().getTime(),
            reset: new Date().getTime(),
            
            score_items: [
                { n_close: 4, n_medium: 0, n_far: 0, score: 100, status: '' },
                { n_close: 2, n_medium: 2, n_far: 0, score: 100, status: '' },
                { n_close: 3, n_medium: 0, n_far: 0, score: 95, status: '' },
                { n_close: 2, n_medium: 1, n_far: 0, score: 95, status: '' },
                { n_close: 2, n_medium: 0, n_far: 0, score: 90, status: '' },
                { n_close: 1, n_medium: 2, n_far: 0, score: 90, status: '' },
                { n_close: 1, n_medium: 1, n_far: 0, score: 85, status: '' },
                { n_close: 0, n_medium: 2, n_far: 0, score: 80, status: '' },
                { n_close: 1, n_medium: 0, n_far: 0, score: 80, status: '' },
                { n_close: 0, n_medium: 1, n_far: 2, score: 80, status: '' },
                { n_close: 0, n_medium: 1, n_far: 0, score: 75, status: '' },
            ],
            fields_1: [
                {
                    key: 'id',
                    label: 'id',
                    class: 'text-center w-230px',
                    sortable: false,
                    visible: false,
                },

                {
                    key: 'keyword',
                    label: 'keyword',
                    class: 'text-center w-230px',
                    sortable: true,
                },
                {
                    key: 'neutra_terms',
                    label: 'Neutralising Terms',
                    class: 'text-center w-230px',
                    sortable: false,
                },
                {
                    key: 'other_words',
                    label: 'Required Terms',
                    class: 'text-center w-230px',
                    sortable: false,
                },
                {
                    key: 'status',
                    label: 'Action',
                    class: 'text-center w-230px',
                    sortable: false,
                },
            ],

            score_fields: [
                {
                    key: 'score',
                    label: 'Score' + ``,

                    class: 'text-center w-230px',
                    sortable: true,
                },
                {
                    key: 'n_close',
                    label: 'Close',
                    class: 'text-center w-230px',
                    sortable: false,
                },
                {
                    key: 'n_medium',
                    label: 'Medium',
                    //       tdClass: 'items_bin_score_field',
                    class: 'text-center w-230px',
                    sortable: false,
                },
                {
                    key: 'n_far',
                    label: 'Far',
                    //         tdClass: 'items_bin_score_field',
                    class: 'text-center w-230px',
                    sortable: false,
                },

                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list text-center w-230px',
                    //   tdClass: 'items_bin_score_field',
                },
            ],

            buttonText: '',

            selected: [],
            selectAll: false,

            isBusy: false,
            isLoading: false,
            useURLRegionBoostAME: false,
            country_items : [
                {
                region: "Local",
                score: 20,
                status: ''
            },
            {
                region: "Residence",
                score: 20,
                status: ''
            },
            {
                region: "Neutral",
                score: 0,
                status: ''
            },
            {
                region: "Foreign",
                score: -20,
                status: ''
            }
            ],
            country_fields: [
                {
                    key: 'region',
                    label: 'Region',
                    class: 'text-center w-230px',
                    
                },
                {
                    key: 'score',
                    label: 'Score',
                    class: 'text-center w-230px',
                  
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'two-list text-center w-230px',
                   
                    //   tdClass: 'items_bin_score_field',
                },
            ],
            URLRegionBoostLocalScoreAME: 20,
            URLRegionBoostResidenceScoreAME: 20,
            URLRegionBoostNeutralScoreAME: 0,
            URLRegionBoostForeignScoreAME: -20,
            showCountryModal: false,
            editedCountryItem: {
                region: '',
                score: ''
            },
            editedCountryIndex: null,
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data' , 'showPageLoader', 'dataSegmentId', 'loading']),

        selected() {
            return this.list.modules.filter((module) => module.selected)
        },
    }, // End of Component > computed
    watch: {
        dataSegmentId(value) {
            console.log('the watch are', value)
            if (value) {
                this.getSarData()
                this.getWebConfig()
                this.getScoreDetails()

            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getSarData()
        this.getWebConfig()
        this.getScoreDetails()

         let type = process.env.VUE_APP_kEYWORD_REGION_MEDIA == "pk_adverse_media" ? "pk_adverse_media_entity" : "uae_adverse_media_entity"
        this.keyword_path =  `configurations/keyword?type=${type}`
    }, // End of Component > methods

    beforeMount() {
        this.getScoreDetails()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        closeModal(modalValue) {
            if (modalValue == 'dob' ){
                this.showModal = false
            } else if (modalValue == 'country') {
                this.showCountryModal = false
            }
         },
         
        openCountryModal(index) {
            console.log("open country modal", index)
            this.editedCountryItem = { ...this.country_items[index] };
            this.editedCountryIndex = index;
            this.showCountryModal = true;
        },
        submitCountryForm() {
            console.log("submit country form func", this.editedCountryIndex)
            if (this.editedCountryIndex !== null) {
                this.country_items[this.editedCountryIndex].score = parseFloat(this.editedCountryItem.score);
                switch (this.editedCountryIndex) {
                    case 0 :
                        this.URLRegionBoostLocalScoreAME = parseFloat(this.editedCountryItem.score)
                        break;
                    case 1 :
                        this.URLRegionBoostResidenceScoreAME =parseFloat(this.editedCountryItem.score)
                        break;
                    case 2 :
                        this.URLRegionBoostNeutralScoreAME =parseFloat(this.editedCountryItem.score)
                        break;
                    case 3 :
                        this.URLRegionBoostForeignScoreAME =parseFloat(this.editedCountryItem.score)
                        break;
                
                    default:
                        break;
                }
                this.closeModal('country');
            }
            console.log("scores local", this.URLRegionBoostLocalScoreAME)
            console.log("scores residence", this.URLRegionBoostResidenceScoreAME)
            console.log("scores neutral", this.URLRegionBoostNeutralScoreAME)
        console.log("scores foreign", this.URLRegionBoostForeignScoreAME)
        },
        setWordScoreRecord(record){
            this.data1 = this.data1.map(el=>{
                if(el._id == record._id){
                    el = {...el, ...record};
                }
                return el;
            })
        },
        
        async loadWordDistanceScore(){
            let  data_score_list  = await sarApi1.list({
                dataSegmentId: this.dataSegmentId,
            })

            this.items_bin_score = this.items_bin_score.map((el)=>{
                let accessor = { 1: 'close', 2: 'medium', 3: 'far' }  // if id ==1 ? 'close' : ...
                let range = accessor[el.id];
                let min = data_score_list.data.data[0][range][0];
                let max = data_score_list.data.data[0][range][1];
                el.score = `${min}-${max} words`;
                return el;
            })
        },

        async getScoreDetails() {
            try {
                this.$store.commit('setLoading', true)

                const ScoreApi = new resource(
                    `configurations/ProximityScore?type=Entity/AM`
                )

                const CategoriApi = new resource(
                    `configurations/CategorieAdverse`
                )
                const KeywordApi = new resource(
                     this.keyword_path
                )
                console.log("keyword api ", KeywordApi)
                let dataSegmentId = this.dataSegmentId
                let [data, dataCategorie, dataKeyword ] = await Promise.all([
                    ScoreApi.get(dataSegmentId), 
                    CategoriApi.get(dataSegmentId), 
                    KeywordApi.get(dataSegmentId)
                ])

                // let data = await ScoreApi.get(this.dataSegmentId)
                // let dataCategorie = await CategoriApi.get(this.dataSegmentId)
                // let dataKeyword = await KeywordApi.get(this.dataSegmentId)

                this.data1 = data.data.data

                this.Adverse_Check_items =
                    dataCategorie.data.data[0].AllCategorieEntity

                this.Adverse_Check_items_most_used =
                    dataCategorie.data.data[0].MostCategorieEntity


                this.data = dataKeyword.data.data
                console.log("keyword data: ", this.data)
                await this.loadWordDistanceScore()

                this.$store.commit('setLoading', false)
                
            } catch(error) {
                console.log(error)
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)
            }
        },

        handleCheckboxChange(item) {
            item.checked = !item.checked
        },

        handleCheckboxChangeMostUsed(item) {
            item.checked = !item.checked
        },

        submitForm() {
            //change item to accordint to array value
            const selectedItems = this.items
                .filter((item) => item.checked)
                .map((item) => item.id)
            console.log(selectedItems)
            // Handle the form submission
        },
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
        sortingScoreChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
        removeField(index, fieldType) {
            fieldType.splice(index, 1)
        },

        addUrlArray() {
          this.url_array.push(''); // add empty value to the fields array
        },
        removeUrlArray(index) {
          this.url_array.splice(index, 1); // remove field at the specified index
        },
        removeRow: function (id) {
            console.log('id', id)
            const index = this.items.findIndex((item) => item.id === id)
            // console.log('Removing', index)
            if (index !== -1) {
                this.items.splice(index, 1)
            }
            // console.log('Removing', index)
            // this.items.splice(index, 1)
        },
        removeRow1: function (index) {
            // console.log('Removing', index)
            this.items_pep.splice(index, 1)
        },

        selectedRecord(record) {
            // console.log('record', record)
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        ChangeThresholdAm(thresholdAME) {
            // console.log('thresholdAME', thresholdAME)
            this.thresholdAME = thresholdAME
        },
        

        select() {
            this.selected = []
            // console.log('t or f', this.selectAll)
            if (!this.selectAll) {
                this.items.forEach((item) => {
                    // console.log('item', item)
                    this.selected.push(item)
                })
                // console.log('selected', this.selected)
            }
            this.selectAll = !this.selectAll
        },
        async getSarData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await sarApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.formData = data.data
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                
                this.showPageLoader = false
            }
        },
        async getWebConfig() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await getwebconfig.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.doAdverseMediaEntity = data.data.doAdverseMediaEntity
                        this.thresholdAME = data.data.thresholdAME
                        this.useCustomKeywordsAME =
                            data.data.useCustomKeywordsAME == true ? false : true
                        this.useSyntaxCheckAME = data.data.useSyntaxCheckAME
                        this.useCategoryCheckAME = data.data.useCategoryCheckAME
                        this.useCustomCategoriesAME =
                            data.data.useCustomCategoriesAME == true
                                ? false
                                : true
                        this.useSentimentCheckAME = data.data.useSentimentCheckAME
                        this.sentimentThresholdAME = parseFloat(
                            data.data.sentimentThresholdAME,
                            10
                        )
                        this.useExcludedURLsAME = data.data.useExcludedURLsAME
                        this.useCustomScoreSetsAME =
                            data.data.useCustomScoreSetsAME == true
                                ? false
                                : true
                         this.useURLRegionBoostAME =
                            data.data.useURLRegionBoostAME == true
                                ? true
                                : false  
                        this.URLRegionBoostLocalScoreAME= parseFloat(data.data.URLRegionBoostLocalScoreAME),
                        this.URLRegionBoostResidenceScoreAME= parseFloat(data.data.URLRegionBoostResidenceScoreAME),
                        this.URLRegionBoostNeutralScoreAME= parseFloat(data.data.URLRegionBoostNeutralScoreAME),
                        this.URLRegionBoostForeignScoreAME= parseFloat(data.data.URLRegionBoostForeignScoreAME),              
                        this.country_items[0].score =data.data.URLRegionBoostLocalScoreAME,
                        this.country_items[1].score =data.data.URLRegionBoostResidenceScoreAME,
                        this.country_items[2].score =data.data.URLRegionBoostNeutralScoreAME,
                        this.country_items[3].score =data.data.URLRegionBoostForeignScoreAME,  
                        console.log("dob items AME", this.country_items)
                        ;(this.useCustomScoreBinsAME =
                            data.data.useCustomScoreBinsAME == true
                                ? false
                                : true),
                                
                            // console.log(data.data.excludedURLsAME)
                        console.log(data.data.excludedURLsAME.length)

                        if (this.url_array[0] == '') {
                            this.url_array=[]
                            for (
                                let i = 0;
                                i < data.data.excludedURLsAME.length;
                                i++
                            ) {
                                const uniqueArr = data.data.excludedURLsAME.filter(
                                    (value, index) => data.data.excludedURLsAME.indexOf(value) === index
                                );
                                // console.log("uniqueArr",uniqueArr)
                                this.url_array.push(uniqueArr[i])
                          //      this.url_array.push(data.data.excludedURLsAME[i])
                                //this.URLS[i].phone = data.data.excludedURLsAME[i]
                            }
                        
                        }

                             
                    }
                    // console.log(this.URLS)
                    this.showPageLoader = false
                }
            } catch (error) {
                this.showPageLoader = false
            }
        },
        async updateSARConfigurations() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                  
                    const filteredArr = this.url_array.filter((value) => value !== '');
                    let findDuplicates = filteredArr => filteredArr.filter((item, index) => filteredArr.indexOf(item) !== index)
                      const duplicateurl =findDuplicates(filteredArr)
                    //   console.log("Dupl",duplicateurl)
                   
                    // Remove duplicates
                    const uniqueArr = filteredArr.filter(
                        (value, index) => filteredArr.indexOf(value) === index
                    );
                    
                      if(duplicateurl.length == 0)
                      {
                    //     console.log(
                    //     'this.useCustomKeywordsAME ',
                    //     this.useCustomKeywordsAME
                    // )
                    let websearchData = {
                        type: 'Entity',
                        Entity: true,
                        keywordRegion:process.env.VUE_APP_kEYWORD_REGION_MEDIA == "pk_adverse_media" ? "pk_adverse_media_entity" : "uae_adverse_media_entity",
                        doAdverseMediaEntity: this.doAdverseMediaEntity,
                        thresholdAME: this.thresholdAME,
                        useCustomKeywordsAME:
                            this.useCustomKeywordsAME == true ? false : true,
                        //array
                        customKeywordsAME: this.customKeywordsAME,
                        useSyntaxCheckAME: this.useSyntaxCheckAME,
                        useCategoryCheckAME: this.useCategoryCheckAME,
                        useCustomCategoriesAME:
                            this.useCustomCategoriesAME == true ? false : true,
                        //array
                        customCategoriesAME: this.Adverse_Check_items,
                        useSentimentCheckAME: this.useSentimentCheckAME,
                        sentimentThresholdAME: this.sentimentThresholdAME.toString(),
                        useExcludedURLsAME: this.useExcludedURLsAME,
                        // array
                        excludedURLsAME: uniqueArr,
                        useCustomScoreSetsAME:
                            this.useCustomScoreSetsAME == true ? false : true,
                        //array
                        customScoreSetsAME: this.customScoreSetsAME,
                        useCustomScoreBinsAME:
                            this.useCustomScoreBinsAME == true ? false : true,
                        // array
                        customScoreBinsAME: this.customScoreBinsAME,
                         useURLRegionBoostAME:
                            this.useURLRegionBoostAME == true ? true : false,
                        URLRegionBoostLocalScoreAME: parseFloat(this.URLRegionBoostLocalScoreAME),
                        URLRegionBoostResidenceScoreAME: parseFloat(this.URLRegionBoostResidenceScoreAME),
                        URLRegionBoostNeutralScoreAME: parseFloat(this.URLRegionBoostNeutralScoreAME),
                        URLRegionBoostForeignScoreAME: parseFloat(this.URLRegionBoostForeignScoreAME),    
                    }
                    // update SAR configuration
                    this.$store.commit('setLoading', true)
                    let { data } = await configApi.update(
                        this.dataSegmentId,
                        websearchData
                    )
                    //   await this.getSarData()
                    await this.getWebConfig()
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setSuccess', data.message)
                      }
                    else{
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', 'URL is same kindly change the URl')

                    }


     
                } catch (error) {
                    console.log(error)
                    this.$store.commit('setError', error)
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        },
        async resetTableData(updateType){
            try{
                this.$store.commit('setLoading', true)

                let payload ={
                    updateOnly: updateType,
                    dataSegmentId: this.dataSegmentId, 
                }

                const {data} = await userWebSearchApi.store(payload);
                if(updateType.toLowerCase().indexOf('score') != -1 || updateType.toLowerCase().indexOf('categor') != -1){
                    await this.getScoreDetails();
                }
                
                this.$store.commit('setLoading', false)
                this.$store.commit('setSuccess', data.message)

            }catch(e){

                this.$store.commit('setLoading', false)
                this.$store.commit('setError', e)
            }
        },

    },
} // End of export default
</script>

<style>
.container {
    width: 300px;
    height: 150px;
    overflow-y: scroll;
}

/* .button {
    background-color: #45ee23;
    border: none;
    color: black;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
} */

.button {
    background-color: #28a745;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button:hover {
    background-color: #28a745;
}

/* .button1 {
    background-color: #ec931e;
    border: none;
    color: black;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
} */

.button1 {
    background-color: #f4c200;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button1:hover {
    background-color: #f4c200;
}

.button2 {
    background-color: #5ddfbed2;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button3 {
    background-color: #ec4848e0;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button3:hover {
    background-color: #ec4848e0;
}

.items_bin_score_field {
    white-space: nowrap;
    width: 1%;
}

#myinput {
  background: linear-gradient(to right, #eb5ad7 0%, #eb5ad7 100%);

  border-radius: 8px;
  height: 7px;
  width: 356px;

  -webkit-appearance: none;
}
</style>
